module.exports = __webpack_public_path__ + "static/media/bell-notification.d8653ed1.wav";